module.exports = __webpack_public_path__ + "img/EXTERIOR-VITARA-3.6df169e4.jpg";